import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import WechatLoginButton from './WechatLoginButton';
import SmsLoginModal from './SmsLoginModal';

/**
 * 第三方登录区（微信 + 手机短信）。
 *
 * 为什么两个按钮合成一个 ItemList 项：
 *   Flarum 核心的 LogInButtons 是给第三方登录扩展各加一个按钮用的，
 *   我们塞两个进去会导致排序被其它扩展的按钮切开、样式也难以统一成一行。
 *   合成一个组件后，只用 -100 这一个优先级就能整体沉到最后。
 *
 * 位置：核心 LogInModal / SignUpModal 的 DOM 顺序是
 *   <LogInButtons /> → <form />
 * 即第三方按钮在表单「上方」。这里不改核心 vnode，
 * 而是用 CSS order（见 resources/less/forum.less）把整块挪到表单下面，
 * 好处是 Flarum 升级时不会因为 body() 结构变化而崩。
 */
export default class AuthButtons extends Component {
  view() {
    return (
      <div className="AcmeAuth">
        <div className="AcmeAuth-divider">
          <span>{app.translator.trans('acme-wechat-sms.forum.other_ways')}</span>
        </div>

        <div className="AcmeAuth-row">
          <WechatLoginButton />

          {/*
            刻意用 <a> 而不是 Flarum 的 <Button> 组件：
            Button 组件会把内容包进 <span class="Button-label">，
            微信按钮是 <a> 直接含 .Button-icon + 文本，两者 DOM 结构不同，
            flex 下图标与文字的对齐行为就不一样（会歪）。
            这里统一成 <a>，两个按钮结构完全一致，样式天然对齐。
            它只是个弹窗触发器，不涉及表单提交，用 <a> 没问题。
          */}
          <a
            className="Button Button--sms"
            href="#"
            onclick={(e) => {
              e.preventDefault();
              app.modal.show(SmsLoginModal);
            }}
          >
            {this.phoneIcon()}
            {app.translator.trans('acme-wechat-sms.forum.sms_login')}
          </a>
        </div>
      </div>
    );
  }

  phoneIcon() {
    // 用 stroke 而不是 fill：手机图标中间要镂空，fill + nonzero 规则容易画错
    return (
      <span className="Button-icon">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
          <rect x="6" y="2" width="12" height="20" rx="2.5" />
          <line x1="10.5" y1="18.5" x2="13.5" y2="18.5" />
        </svg>
      </span>
    );
  }
}
